import { render, staticRenderFns } from "./FamilyForm.vue?vue&type=template&id=4b20234b&"
import script from "./FamilyForm.vue?vue&type=script&lang=js&"
export * from "./FamilyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports